import { SliceZone } from '@prismicio/react';

import { BenefitsPlanTableSlice } from './BenefitsPlanTableSlice';
import { TableSlice } from './TableSlice';
import { TwoFourColumnsTable } from './TwoFourColumnsTable';

export function LinkToPricingTableSlice({ slice }) {
  const { primary, context } = slice;

  // Init empty state when pricing table link is not set so the title and description still renders
  let newBody = [{ slice_type: 'benefits_table_3_column', primary, fields: [], context }];

  if (primary.pricing_table_link) {
    const {
      pricing_table_link: { body },
    } = primary;

    newBody = body.map((item) => ({
      ...item,
      primary: { ...item.primary, ...primary },
      context,
    }));
  }

  const components = {
    benefits_table_3_column: TableSlice,
    pricing_plan_table: BenefitsPlanTableSlice,
    table_two_three_four_column: TwoFourColumnsTable,
  };
  return <SliceZone slices={newBody} components={components} />;
}
